import { encartPackProduitsTitreTexteLogosMock, listingCoinRepasMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

export const blocks = [encartPackProduitsTitreTexteLogosMock(), listingCoinRepasMock];

export const coinRepasMock: SlugPage = {
  ...pageBase({
    title: 'Coin Repas',
    type: 'coin-repas',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
